import {useEffect, useState} from 'react';

const UseDebounceSearch = (search: string, delay: number) => {
    const [value, setValue] = useState<string>("");

    useEffect(() => {
        const setTimeOut = setTimeout(() => {
            setValue(search);
        }, delay)
        return () => clearTimeout(setTimeOut);
    }, [delay, search]);
    return value
};

export default UseDebounceSearch;